// import type { RouteRecordRaw } from 'vue-router';

const routes: any = [
  {
    path: '/',
    redirect: () => {
      return { path: '/chat' }
    }
  },

  /* 内嵌到his医生端 -- start */
  {
    path: '/iHosp',
    children: [
      {
        path: '',
        redirect: () => {
          return { path: '/iHosp/chat' }
        }
      },
      {
        path: 'chat',
        name: 'iHospChat',
        component: () => import('@/views/iHosp/chat.vue'),
        meta: {
          keepAlive: true
        }
      }
    ]
  },
  /* 内嵌到his医生端 -- start */

  /* 聊天模块 -- start */
  {
    path: '/chat',
    name: 'chat',
    component: () => import('@/views/chat/index.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/citySelect',
    name: 'citySelect',
    component: () => import('@/views/citySelect.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/logistics',
    name: 'logistics',
    component: () => import('@/views/logistics/index.vue'),
    meta: {
      keepAlive: false
    }
  },
  /* 聊天模块 -- end */

  /* 预问诊模块 -- start */
  // 预问诊
  {
    path: '/preConsultation',
    name: 'preConsultation',
    component: () => import('@/views/pre-consultation/index.vue'),
    meta: {
      keepAlive: false
    }
  },
  // 预问诊-舌诊拍照
  {
    path: '/photograph',
    name: 'photograph',
    component: () => import('@/views/pre-consultation/photograph.vue'),
    meta: {
      keepAlive: false
    }
  },
  // 预问诊历史列表
  {
    path: '/preConsultationHistoryList',
    name: 'preConsultationHistoryList',
    component: () => import('@/views/pre-consultation/history-list.vue'),
    meta: {
      keepAlive: false
    }
  },
  /* 预问诊模块 -- end */

  /* AI专家分身诊室 -- start */
  {
    path: '/expertCloneRoom',
    children: [
      {
        path: '',
        redirect: () => {
          return { path: '/expertCloneRoom/chat' }
        }
      },
      {
        path: 'chat',
        name: 'expertCloneRoomChat',
        component: () => import('@/views/expertCloneRoom/chat.vue'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: '/expertCloneRoom/expertConsultationForm',
        name: 'expertConsultationForm',
        component: () => import('@/views/expertCloneRoom/expertConsultationForm.vue'),
        meta: {
          keepAlive: true
        }
      }
    ]
  },
  /* AI专家分身诊室 -- end */

  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/test/index.vue'),
    meta: {
      keepAlive: false
    }
  }
]

export default routes
